import { Box } from '@mui/material'
import styles from '@/components/Settings/SettingsSliderControl.module.scss'

/** @param {{ Icon?: import('react').ComponentType }} props */
export function SettingsSliderEdgeIcon({ Icon }) {
  if (!Icon) return null
  return (
    <Box component="span" className={styles.edgeIcon} aria-hidden>
      <Icon />
    </Box>
  )
}
